/* TG SALON LABEL.M
   Add-to-bag for the salon page LABEL.M cards (tg-salon-product-card.liquid).
   Mirrors the ProductCard pattern in assets/global.js: POST FormData with the
   cart drawer's sections, then cartDrawer.renderContents() and
   updateCartCounters(). With no <cart-drawer> on the page the form submits
   normally to /cart/add. The file can be included twice (hero block and edit
   section), so it guards against double binding. */
(function () {
  'use strict';

  if (window.tgSalonLabelmBound) return;
  window.tgSalonLabelmBound = true;

  var ADDED_MS = 2000;

  function addUrl() {
    var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return base.replace(/\.js$/, '') + '.js';
  }

  function setStatus(form, text) {
    var el = form.querySelector('[data-tg-slm-status]');
    if (el) el.textContent = text;
  }

  function setLabel(btn, text) {
    var t = btn.querySelector('.tg-slm-card__btn-text');
    if (t) t.textContent = text;
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-tg-slm-form]')) return;

    var cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function' || !window.fetch) {
      return; /* no drawer: let the browser submit to /cart/add */
    }

    event.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;

    var title = form.getAttribute('data-product-title') || 'Item';
    var label = btn.getAttribute('data-tg-slm-label') || 'Add';

    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    setLabel(btn, 'Adding');
    setStatus(form, 'Adding ' + title + ' to bag');

    var formData = new FormData(form);
    if (typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) { return s.section; })
      );
      formData.append('sections_url', window.location.pathname);
    }
    if (typeof cart.setActiveElement === 'function') {
      cart.setActiveElement(document.activeElement);
    }

    var success = false;

    fetch(addUrl(), {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status || response.errors) {
          var msg = response.description || response.message || response.errors || 'Could not add to bag';
          setStatus(form, String(msg));
          return;
        }
        success = true;
        cart.renderContents(response);
        if (typeof window.updateCartCounters === 'function') window.updateCartCounters();
        setStatus(form, title + ' added to bag');
      })
      .catch(function (err) {
        console.error(err);
        setStatus(form, 'Could not add ' + title + ' to bag. Please try again.');
      })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        if (success) {
          btn.classList.add('is-added');
          setLabel(btn, 'Added');
          window.setTimeout(function () {
            btn.classList.remove('is-added');
            setLabel(btn, label);
          }, ADDED_MS);
        } else {
          setLabel(btn, label);
        }
      });
  }

  document.addEventListener('submit', onSubmit);
})();
